/* istanbul ignore file */
export * from './Recommendations';
